import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/clickdrive.webp';
import screenshot_target from '../../../images/letterfunnel/joostvansuijlekom.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Joost van Suijlekom"
      firstname="Joost"
      companyname="Clickdrive"
      competition="Rijles.nl en NXXT Verkeersscholen"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/joostvansuijlekom.js